import React, { forwardRef } from 'react';
import css from './textarea.module.scss';
import { TextareaAutosize as TextareaAutosizeBase } from '@mui/base/TextareaAutosize';
import clsx from 'clsx';

type Props = {
  border?: boolean;
} & React.ComponentProps<typeof TextareaAutosizeBase>;

const Textarea = forwardRef<HTMLTextAreaElement, Props>((props, ref) => {
  const { border = true, ...rest } = props;

  return (
    <TextareaAutosizeBase
      disabled={props.disabled || props.readOnly}
      {...rest}
      ref={ref}
      className={clsx(css.root, border && css.border, {
        [css.disabled]: props.disabled || props.readOnly,
      })}
    />
  );
});

export default Textarea;
